import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import FilterSelect from 'features/IRWorkstation/components/Common/FilterSelect';

const FILTER_MAX_LIST_HEIGHT = 200;

const ALL_INVESTOR_TYPES = { label: 'All investor types', value: '' };
const ALL_COVERAGE_TIERS = { label: 'All coverage tiers', value: '' };
const ALL_INTERNAL_COVERAGE = { label: 'All internal coverage', value: '' };
const ALL_HEALTH = { label: 'All health', value: '' };

// Options come from the API; a failed fetch leaves each dropdown with just its "All" option.
const AllLPsFilters = ({ filters, options, onChange, onReset, hasSearch }) => {
	const handleChange = (key, value) => onChange(key, value);

	const hasActiveFilters =
		Object.values(filters).some((value) => value !== '') || hasSearch;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1,
				padding: '8px 14px',
				borderBottom: '0.5px solid',
				borderColor: 'border.light',
				flexWrap: 'wrap',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 2,
					flex: 1,
					flexWrap: 'wrap',
				}}
			>
				<FilterSelect
					data-testid='lp-investor-type-filter'
					maxListHeight={FILTER_MAX_LIST_HEIGHT}
					width={170}
					height={40}
					value={filters.investor_type}
					options={[ALL_INVESTOR_TYPES, ...(options?.investor_type || [])]}
					onChange={(value) => handleChange('investor_type', value)}
				/>

				<FilterSelect
					data-testid='lp-coverage-tier-filter'
					maxListHeight={FILTER_MAX_LIST_HEIGHT}
					width={170}
					height={40}
					value={filters.coverage_tier}
					options={[ALL_COVERAGE_TIERS, ...(options?.coverage_tier || [])]}
					onChange={(value) => handleChange('coverage_tier', value)}
				/>

				<FilterSelect
					data-testid='lp-internal-coverage-filter'
					maxListHeight={FILTER_MAX_LIST_HEIGHT}
					width={190}
					height={40}
					value={filters.internal_coverage}
					options={[
						ALL_INTERNAL_COVERAGE,
						...(options?.internal_coverage || []),
					]}
					onChange={(value) => handleChange('internal_coverage', value)}
				/>

				<FilterSelect
					data-testid='lp-health-filter'
					maxListHeight={FILTER_MAX_LIST_HEIGHT}
					width={170}
					height={40}
					value={filters.health}
					options={[ALL_HEALTH, ...(options?.health || [])]}
					onChange={(value) => handleChange('health', value)}
				/>
			</Box>

			{hasActiveFilters && (
				<Button
					data-testid='lp-reset-filters'
					variant='outlined'
					size='small'
					onClick={onReset}
					sx={{ fontSize: '12px', whiteSpace: 'nowrap' }}
				>
					Reset filters
				</Button>
			)}
		</Box>
	);
};

AllLPsFilters.propTypes = {
	filters: PropTypes.shape({
		investor_type: PropTypes.string.isRequired,
		coverage_tier: PropTypes.string.isRequired,
		internal_coverage: PropTypes.string.isRequired,
		health: PropTypes.string.isRequired,
	}).isRequired,
	options: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	onReset: PropTypes.func.isRequired,
	hasSearch: PropTypes.bool,
};

export default AllLPsFilters;
